/* v49: local prices. Asks the Glow Scan Worker which price this visitor pays.
   India (or anyone, until the Worker variable INTL_PRICES is on): nothing changes.
   USA: $10, UAE: AED 25, other countries: $10. Then the Glow Scan prices on the page are swapped,
   and India-only offers (the Diwali band and its strike-through price) are hidden.
   Test from India with ?gs_cc=US or ?gs_cc=AE on any page (display only; payment still uses the real country). */
(function () {
  var EP = 'https://glow-scan-api.theraglam-store.workers.dev', root = document.querySelector('.gs');
  if (root && root.dataset.endpoint) EP = root.dataset.endpoint.replace(/\/+$/, '');
  var K = 'gsLP', m = /[?&]gs_cc=([A-Za-z]{2})/.exec(location.search), cc = m ? m[1].toUpperCase() : '';
  function sym(cur, v) { return (cur === 'USD' ? '$' : cur + ' ') + v; }
  function go(L) {
    window.glowLP = L;
    if (!L || !L.currency || L.currency === 'INR') return;
    document.documentElement.classList.add('gs-intl');
    var st = document.createElement('style');
    st.textContent = '.gs-intl .gdw,.gs-intl [class*="gdw-bar"],.gs-intl [class*="gdw-sticky"],.gs-intl .gs-ofr{display:none!important}';
    document.head.appendChild(st);
    var perDay = sym(L.currency, (L.amount / 100 / 30).toFixed(2));
    var RX = /(?:Rs\.?|₹|INR)\s?(599|199|449|149)(?:\.00)?(?![\d,])/g, DX = /about (?:Rs\.?|₹)\s?\d+ a day/g;
    function fixText(t) {
      var v = t.nodeValue, p = t.parentNode;
      if (!v || !/Rs|₹|INR/.test(v) || !p || /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(p.nodeName)) return;
      if (/^(S|DEL)$/.test(p.nodeName) && /599/.test(v)) { p.style.display = 'none'; return; }
      var nv = v.replace(DX, 'about ' + perDay + ' a day').replace(RX, function (all, a) { return (a === '449' || a === '149') && L.renew ? L.renew.text : L.text; });
      if (nv !== v) t.nodeValue = nv;
    }
    function fix(node) {
      if (!node) return;
      if (node.nodeType === 3) return fixText(node);
      if (node.nodeType !== 1) return;
      var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null), n, a = [];
      while ((n = w.nextNode())) a.push(n);
      a.forEach(fixText);
    }
    fix(document.body);
    new MutationObserver(function (ms) { ms.forEach(function (x) { x.addedNodes.forEach(fix); }); }).observe(document.body, { childList: true, subtree: true });
  }
  function start(L) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { go(L); }); else go(L); }
  try { var c = JSON.parse(sessionStorage.getItem(K) || 'null'); if (c && c.cc === cc && c.t > Date.now() - 3600e3) { start(c.v); return; } } catch (e) {}
  fetch(EP + '/pay/price' + (cc ? '?cc=' + cc : ''), { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (j) {
    if (!j || !j.ok) return;
    try { sessionStorage.setItem(K, JSON.stringify({ t: Date.now(), cc: cc, v: j })); } catch (e) {}
    start(j);
  }).catch(function () {});
})();
